import React from 'react';

import { Table, Column, HeaderCell, Cell, ColumnGroup} from 'rsuite-table';
import 'rsuite-table/dist/css/rsuite-table.css';

const baseTableProps = {
    height: 720,
};

const baseStyles = {
    zIndex: 0,
}
export const UserGrid = ({dataSource, onRowClick}) => {
    return (
     <Table data={dataSource} {...baseTableProps} style={baseStyles} onRowClick={onRowClick}>
            <Column width={200} fixed sortable resizable>
                <HeaderCell>First Name</HeaderCell>
                <Cell>{rowData => rowData?.firstName}</Cell>
            </Column>
            <Column width={200} fixed sortable resizable>
                <HeaderCell>Last Name</HeaderCell>
                <Cell>{rowData => rowData?.lastName}</Cell>
            </Column>
            <Column width={200} fixed sortable resizable>
                <HeaderCell>Email Address</HeaderCell>
                <Cell>{rowData => rowData.userName}</Cell>
            </Column>
            <Column width={140} fixed sortable resizable>
                <HeaderCell>DOB</HeaderCell>
                <Cell>{rowData => new Date(rowData.dob).toLocaleDateString('en-US', {
                    month: '2-digit',
                    day: '2-digit',
                    year: 'numeric'
                    })}
                </Cell>
            </Column>
            <Column width={150} fixed sortable resizable>
                <HeaderCell>Gender</HeaderCell>
                <Cell>{rowData => rowData.gender}</Cell>
            </Column>
            <Column width={100} fixed sortable resizable>
                <HeaderCell>Is Active</HeaderCell>
                <Cell>{rowData => (
                         <input
                             type="checkbox"
                             checked={rowData.status === "ACTIVE"}
                             onChange={event => {
                                 event.stopPropagation();
                                //  onRowClick(rowData);
                             }}
                             style={{ marginLeft: 10 }}
                             disabled
                         />
                )}</Cell>
            </Column>           
        </Table>
    )
}